// extracted by mini-css-extract-plugin
export var menuIcon = "_td-0";
export var menuIconInline = "_td-1";